import 'emoji-mart/css/emoji-mart.css'
import './styles.scss'
import React, { useState } from 'react'
import ModalWrapper from 'components/ModalWrapper'
import AudioRecorder from 'components/AudioRecorder'
import { ButtonSpeechTranscription, SendButton } from 'components/common'
import Browser from 'utils/Browser'
import { getStaticImage } from 'utils/statics'
import { FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import { lang } from 'utils/helpers'
import UploadFiles from 'components/UploadFiles'
import Camera from 'components/Camera'
import EmojiSelector from 'components/EmojiSelector'
import { useDispatch } from 'react-redux'
import inchatActions from 'redux/inchat/actions'
import { toastMessage } from 'utils/messages'
import { apiInchat } from 'api'

const ActionsBar = ({
  composer,
  conversationId,
  newConversationId,
  disabledSend,
  onToggleReset,
  onSendMessage,
  channel,
  updateEditor,
  refEditor,
  isThread,
  toggleScheduleMsgModal,
  handleScheduleMessage
}) => {
  const dispatch = useDispatch()
  const supportVideoCamera = Browser.supportVideoCamera()
  const [showAttachments, setShowAttachments] = useState(false)
  const [showAudioRecorder, setShowAudioRecorder] = useState(false)
  const [showCameraPhoto, setShowCameraPhoto] = useState(false)
  const [showCameraVideo, setShowCameraVideo] = useState(false)
  const [showEmojis, setShowEmojis] = useState(false)
  const files = []
  const onToggleAttachments = () => setShowAttachments(!showAttachments)
  const onToggleAudioRecorder = () => setShowAudioRecorder(!showAudioRecorder)
  const onToggleCameraPhoto = () => setShowCameraPhoto(!showCameraPhoto)
  const onToggleCameraVideo = () => setShowCameraVideo(!showCameraVideo)
  const onToggleEmojis = () => setShowEmojis(!showEmojis)

  const onSelectEmoji = (emoji) => {
    refEditor && refEditor.selection.insertHTML(emoji.native)
    onToggleEmojis()
  }

  const sendPhoto = async (cameraPhotoUrl) => {
    try {
      await dispatch(inchatActions.uploadFiles([{ file: cameraPhotoUrl }], conversationId, isThread, newConversationId))
      onToggleCameraPhoto()
    } catch (error) {
      toastMessage(lang(error), 'error')
    }
  }
  const sendVideo = async (cameraVideoUrl) => {
    try {
      await dispatch(inchatActions.uploadFiles([{ file: cameraVideoUrl }], conversationId, isThread, newConversationId))
      onToggleCameraVideo()
    } catch (error) {
      toastMessage(lang(error), 'error')
    }
  }

  const uploadAudio = async (value) => {
    const time = new Date().getTime()
    const file = new File([value.blob], `voice-${time}.wav`, { type: 'audio/wav' })
    try {
      await dispatch(inchatActions.uploadFiles([{ file: file }], conversationId, isThread, newConversationId))
      onToggleAudioRecorder()
    } catch (error) {
      toastMessage(lang(error), 'error')
    }
  }

  const uploadFiles = async (files) => {
    try {
      await dispatch(inchatActions.uploadFiles(files, conversationId, isThread, newConversationId))
    } catch (error) {
      toastMessage(lang(error), 'error')
    }
  }

  const removeFile = (file) => {}

  const optionsSendButton = [
    [
      {
        closeMenu: true,
        label: lang('dashboard_tomorrow-at-0900'),
        onClick: () => handleScheduleMessage({ dateType: 'tomorrow-0900' })
      },
      {
        closeMenu: true,
        label: lang('dashboard_monday-at-0900'),
        onClick: () => handleScheduleMessage({ dateType: 'monday-0900' })
      },
    ],
    [
      {
        closeMenu: true,
        label: `${lang('dashboard_another-moment')}...`,
        onClick: toggleScheduleMsgModal
      }
    ]
  ]

  const cleanComposer = async () => {
    try {
      if (composer.draftId) {
        // ELIMINAR EL BORRADOR EN CASO DE EXISTIR EN BASE DE DATOS
        await apiInchat.draftRemove({ conversationId, draftId: composer.draftId })
      }
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(inchatActions.cleanComposer(newConversationId, isThread))
    }
  }

  return (
    <div className={'actions-bar'}>
      <div className='actions-container' >
        {/* RESET COMPOSER */}
        {!disabledSend && (
          <button
            type='button'
            title={lang('dashboard_clean-up')}
            className='reset-composer-btn'
            onClick={cleanComposer}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Reset' />
            </figure>
          </button>
        )}

        {/* ATTACHMENTS */}
        <button
          type='button'
          title={lang('dashboard_add-attachments')}
          className='icon-btn'
          onClick={onToggleAttachments}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-clip-grey.svg')} alt='Attachments' />
          </figure>
        </button>

        {/* AUDIO TRANSCRIPTION */}
        <ButtonSpeechTranscription
          composerMessage={composer?.message || ''}
          channel={channel}
          addExternalText={(text) => updateEditor(text)}
        />

        {/* AUDIO RECORDER */}
        <button
          type='button'
          title={lang('dashboard_record-voice-memo')}
          className='icon-btn'
          onClick={onToggleAudioRecorder}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-mic-grey.svg')} alt='Audio recorder' />
          </figure>
        </button>

        {/* CAMERA */}
        <button
          type='button'
          title={lang('dashboard_capture-photo')}
          className='icon-btn'
          onClick={onToggleCameraPhoto}
        >
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-camera-grey.svg')} alt='camera' />
          </figure>
        </button>

        {/* VIDEO CAMERA */}
        {supportVideoCamera && (
          <button
            type='button'
            title={lang('dashboard_record-video')}
            className='icon-btn'
            onClick={onToggleCameraVideo}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-video-grey.svg')} alt='Video' />
            </figure>
          </button>
        )}

        {/* EMOJIS */}
        <div className='emojis'>
          <button
            type='button'
            title='Emojis'
            className='icon-btn'
            onClick={onToggleEmojis}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-emoji-grey.svg')} alt='Emojis' />
            </figure>
          </button>

          {/* MODAL - EMOJIS */}
          <EmojiSelector
            showEmojis={showEmojis}
            handleToggle={onToggleEmojis}
            handleSelect={onSelectEmoji}
          />
        </div>

        {/* SUBMIT BUTTON */}
        <SendButton
          optionsMenu={!isThread && optionsSendButton}
          onClick={onSendMessage}
          disabledSend={disabledSend}
        />
      </div>

      {/* MODAL - CAMERA (PHOTO) */}
      <Camera
        type='photo'
        showCamera={showCameraPhoto}
        onCloseModal={onToggleCameraPhoto}
        sendData={sendPhoto}
      />

      {/* MODAL - CAMERA (VIDEO) */}
      <Camera
        type='video'
        showCamera={showCameraVideo}
        onCloseModal={onToggleCameraVideo}
        sendData={sendVideo}
        uploading={composer?.uploading}
      />

      {/* MODAL - AUDIO RECORDER */}
      <AudioRecorder
        uploadAudio={uploadAudio}
        showAudioRecorder={showAudioRecorder}
        onCloseModal={onToggleAudioRecorder}
        uploading={composer?.uploading}
      />

      {/* MODAL - ATTACHMENTS */}
      <ModalWrapper
        isOpen={showAttachments}
        toggle={onToggleAttachments}
        header={lang('dashboard_upload-files')}
        body={
          <UploadFiles
            uploadFiles={uploadFiles}
            cancel={onToggleAttachments}
            filesUploaded={files}
            onRemoveUploadedFile={removeFile}
            uploading={composer?.uploading}
            maxSize={FILE_MAX_SIZE_CONVERSATION}
            labelSize={lang('placeholder_max_file_size')}
            messageErrorSize={lang('file-too-big')}
            acceptTypes={''}
          />
        }
      />
    </div>
  )
}

export default ActionsBar
